import { Fragment } from "react";
import "./GursikhiDevelopment.css"


const GurshikhaProject = () => {
    return (
        <Fragment>
            <div className="main">
                <div>
                    <h1>Project: The Gursikhi Development Initiative </h1>

                    <p>"This framework, The Gursikhi Development Initiative, outlines age-specific content strategies to engage individuals with Gursikhi principles from infancy to pre-retirement. Recognizing evolving learning needs, it provides tailored content for 30 age groups to foster a deeper understanding and practice of Sikh values throughout life. This framework guides educators and families in nurturing a lifelong connection with Gursikhi and can be enhanced through ongoing community feedback and expert collaboration." </p>

                    <h3>Teams Involved: </h3>
                    <ul>
                        <li>Gurbani Education & Youth Engagement Team (Gurbani, Education, Youth) </li>
                        <li>Community Development & Outreach Team (Community, Family, Adults) </li>
                        <li>All Teams (Collaboration, Events, Resources) </li>
                    </ul>

                    <h3>Age Groups: </h3>
                    <p>The 2-year age gaps and 30 groups are adopted to precisely tailor Gursikhi education to the distinct developmental, cognitive, social, and emotional needs of individuals across the lifespan, maximizing relevance and engagement. </p>

                    <ul>
                        <li>Group 0: 12 Months Before Birth </li>
                        <li>Group 1: 0-2 years </li>
                        <li>Group 2: 3-4 years </li>
                        <li>Group 3: 5-6 years </li>
                        <li>Group 4: 7-8 years </li>
                        <li>Group 5: 9-10 years </li>
                        <li>Group 6: 11-12 years </li>
                        <li>Group 7: 13-14 years </li>
                        <li>Group 8: 15-16 years </li>
                        <li>Group 9: 17-18 years </li>
                        <li>Group 10: 19-20 years </li>
                        <li>Group 11: 21-22 years </li>
                        <li>Group 12: 23-24 years </li>
                        <li>Group 13: 25-26 years </li>
                        <li>Group 14: 27-28 years </li>
                        <li>Group 15: 29-30 years </li>
                        <li>Group 16: 31-32 years </li>
                        <li>Group 17: 33-34 years </li>
                        <li>Group 18: 35-36 years </li>
                        <li>Group 19: 37-38 years </li>
                        <li>Group 20: 39-40 years </li>
                        <li>Group 21: 41-42 years </li>
                        <li>Group 22: 43-44 years </li>
                        <li>Group 23: 45-46 years </li>
                        <li>Group 24: 47-48 years </li>
                        <li>Group 25: 49-50 years </li>
                        <li>Group 26: 51-52 years </li>
                        <li>Group 27: 53-54 years </li>
                        <li>Group 28: 55-56 years </li>
                        <li>Group 29: 57-58 years </li>
                        <li>Group 30: 59-60 years </li>
                    </ul>

                    <h2>Content Outlines by Age Group</h2>

                    <h3>Category: Early Childhood</h3>

                    <h4>Group 0: 12 Months Before Birth </h4>
                    <ul>
                        <li>Core Focus: Meditation, Listen to Gurbani and do Simran Everytime </li>
                        <li>Key Principles: Reading and listening Gurbani </li>
                        <li>Content & Activities: 
                            <ul>
                                <li>Mool Mantar Jaap </li>
                                <li>Sukhmani Sahib </li>
                                <li>Dhan Guru Dhan Singh Shaheed </li>
                                <li>Get Kaeda and Start at Home </li>
                            </ul>
                        </li>
                        <li>Team: Gurbani Curriculum, Outreach </li>
                    </ul>

                    <h4>Group 1: 0-2 years </h4>
                    <ul>
                        <li>Core Focus: Sensory, emotional connection to Gurbani. </li>
                        <li>Key Principles: Sound immersion, comfort, visual/tactile exploration. </li>
                    </ul>

                    <h4>Group 2: 3-4 years </h4>
                    <ul>
                        <li>Core Focus: Basic concepts, stories, play. </li>
                        <li>Key Principles: Simple narratives, interactive play, vocabulary. </li>
                        <li>Content & Activities: 
                            <ul>
                                <li>Guru stories (puppets, books). </li>
                                <li>Simple Shabad singing. </li>
                                <li>Coloring, crafts. </li>
                                <li>Games with Sikh values. </li>
                                <li>Parent-child activities. </li>
                            </ul>
                        </li>
                        <li>Team: Gurbani Curriculum, Youth Programs, Outreach </li>
                    </ul>

                    <h4>Group 3: 5-6 years </h4>
                    <ul>
                        <li>Core Focus: Foundation, history, Punjabi basics. </li>
                        <li>Key Principles: Structured play, early literacy, curiosity. </li>
                        <li>Content & Activities: 
                            <ul>
                                <li>Guru names, timelines, maps. </li>
                                <li>Punjabi alphabet, words. </li>
                                <li>Short Shabad memorization. </li>
                                <li>Interactive Q&A.]</li>
                                <li>Gurdwara tours.]</li>
                            </ul>
                        </li>
                        <li>Team: Gurbani Curriculum, Youth Programs]</li>
                    </ul>

                    <h3>Category: Childhood and Pre-Adolescence</h3>

                    <h4>Group 4: 7-8 years]</h4>
                    <ul>
                        <li>Core Focus: Expanding history, reading, writing.]</li>
                        <li>Key Principles: Deeper stories, language skills, ethics.]</li>
                        <li>Content & Activities:]
                            <ul>
                                <li>Detailed Guru biographies.]</li>
                                <li>Punjabi reading/writing.]</li>
                                <li>Simple Saakhis.]</li>
                                <li>Art projects.]</li>
                                <li>Moral value-based scenarios.]</li>
                            </ul>
                        </li>
                        <li>Team: Gurbani Curriculum, Youth Programs]</li>
                    </ul>

                    <h4>Group 5: 9-10 years]</h4>
                    <ul>
                        <li>Core Focus: Sikh identity, community, Seva.]</li>
                        <li>Key Principles: Belonging, responsibility, action.]</li>
                        <li>Content & Activities:]
                            <ul>
                                <li>Sikh symbols, identity.]</li>
                                <li>Gurdwara Seva projects.]</li>
                                <li>Community interaction.]</li>
                                <li>Role models.]</li>
                                <li>Basic research skills.]</li>
                            </ul>
                        </li>
                        <li>Team: Youth Programs, Outreach]</li>
                    </ul>

                    <h4>Group 6: 11-12 years]</h4>
                    <ul>
                        <li>Core Focus: Critical thinking, Gurbani context.]</li>
                        <li>Key Principles: Analysis, application, discussion.]</li>
                        <li>Content & Activities:]
                            <ul>
                                <li>Shabad analysis (stories, context).]</li>
                                <li>Ethical debates.]</li>
                                <li>Presentations.]</li>
                                <li>Digital storytelling.]</li>
                                <li>Leadership skills.]</li>
                            </ul>
                        </li>
                        <li>Team: Youth Programs, Digital Engagement]</li>
                    </ul>

                    <h3>Category: Adolescence</h3>

                    <h4>Group 7: 13-14 years]</h4>
                    <ul>
                        <li>Core Focus: Identity, challenges, peer pressure.]</li>
                        <li>Key Principles: Self-awareness, resilience, support.]</li>
                        <li>Content & Activities:]
                            <ul>
                                <li>Sikh identity in modern world.]</li>
                                <li>Peer pressure strategies.]</li>
                                <li>Stress management.]</li>
                                <li>Role model interaction.]</li>
                                <li>Creative projects (music, art).]</li>
                            </ul>
                        </li>
                        <li>Team: Youth Programs]</li>
                    </ul>

                    <h4>Group 8: 15-16 years]</h4>
                    <ul>
                        <li>Core Focus: Gurbani application, service, leadership.]</li>
                        <li>Key Principles: Action, impact, responsibility.]</li>
                        <li>Content & Activities:]
                            <ul>
                                <li>Advanced Gurbani study.]</li>
                                <li>Community service projects.]</li>
                                <li>Mentorship opportunities.]</li>
                                <li>Event planning.]</li>
                                <li>Digital activism.]</li>
                            </ul>
                        </li>
                        <li>Team: Youth Programs, Collaboration]</li>
                    </ul>

                    <h4>Group 9: 17-18 years]</h4>
                    <ul>
                        <li>Core Focus: College/career prep, Sikh values.]</li>
                        <li>Key Principles: Purpose, ethics, decision-making.]</li>
                        <li>Content & Activities:]
                            <ul>
                                <li>Ethical career choices.]</li>
                                <li>Gurbani in decision-making.]</li>
                                <li>Leadership roles.]</li>
                                <li>College/scholarship guidance.]</li>
                                <li>Debate and public speaking.]</li>
                            </ul>
                        </li>
                        <li>Team: Youth Programs, Digital Engagement]</li>
                    </ul>

                    <h3>Category: Young Adulthood</h3>

                    <h4>Group 10: 19-20 years]</h4>
                    <ul>
                        <li>Core Focus: Navigating early adulthood, identity.]</li>
                        <li>Key Principles: Self-discovery, balance, community.]</li>
                        <li>Content & Activities:]
                            <ul>
                                <li>Discussions on identity and belonging.]</li>
                                <li>Gurbani for life challenges.]</li>
                                <li>Networking events.]</li>
                                <li>Creative expression.]</li>
                                <li>Mentorship from older adults.]</li>
                            </ul>
                        </li>
                        <li>Team: Youth Programs, Collaboration]</li>
                    </ul>

                    <h4>Group 11: 21-22 years]</h4>
                    <ul>
                        <li>Core Focus: Career, relationships, personal growth.]</li>
                        <li>Key Principles: Responsibility, commitment, values.]</li>
                        <li>Content & Activities:]
                            <ul>
                                <li>Workplace ethics.]</li>
                                <li>Healthy relationships.]</li>
                                <li>Financial literacy.]</li>
                                <li>Personal development workshops.]</li>
                                <li>Community leadership opportunities.]</li>
                            </ul>
                        </li>
                        <li>Team: Youth Programs, Outreach]</li>
                    </ul>

                    <h4>Group 12: 23-24 years]</h4>
                    <ul>
                        <li>Core Focus: Family planning, community building.]</li>
                        <li>Key Principles: Marriage, parenting, seva.]</li>
                        <li>Content & Activities:]
                            <ul>
                                <li>Pre-marriage counseling.]</li>
                                <li>Parenting seminars.]</li>
                                <li>Community service.]</li>
                                <li>Gurdwara roles.]</li>
                                <li>Family events.]</li>
                            </ul>
                        </li>
                        <li>Team: Community Development]</li>
                    </ul>

                    <h3>Category: Adulthood</h3>

                    <h4>Group 13: 25-26 years]</h4>
                    <ul>
                        <li>Core Focus: Establishing career, family values.]</li>
                        <li>Key Principles: Balance, responsibility, community.]</li>
                        <li>Content & Activities:]
                            <ul>
                                <li>Work-life balance.]</li>
                                <li>Raising children with Sikh values.]</li>
                                <li>Gurdwara involvement.]</li>
                                <li>Mentorship.]</li>
                                <li>Family workshops.]</li>
                            </ul>
                        </li>
                        <li>Team: Community Development]</li>
                    </ul>

                    <h4>Group 14: 27-28 years]</h4>
                    <ul>
                        <li>Core Focus: Deepening Gurbani, seva.]</li>
                        <li>Key Principles: Reflection, action, growth.]</li>
                        <li>Content & Activities:]
                            <ul>
                                <li>Advanced Gurbani study.]</li>
                                <li>Community leadership.]</li>
                                <li>Mentoring youth.]</li>
                                <li>Personal development.]</li>
                                <li>Ethical decision-making.]</li>
                            </ul>
                        </li>
                        <li>Team: Gurbani Curriculum, Community Development]</li>
                    </ul>

                    <h4>Group 15: 29-30 years]</h4>
                    <ul>
                        <li>Core Focus: Family, career, community impact.]</li>
                        <li>Key Principles: Contribution, legacy, purpose.]</li>
                        <li>Content & Activities:]
                            <ul>
                                <li>Family and professional ethics.]</li>
                                <li>Community projects.]</li>
                                <li>Mentoring.]</li>
                                <li>Gurdwara governance.]</li>
                                <li>Philanthropy.]</li>
                            </ul>
                        </li>
                        <li>Team: All Teams]</li>
                    </ul>

                    <h4>Group 16: 31-32 years]</h4>
                    <ul>
                        <li>Core Focus: Balancing career and family.]</li>
                        <li>Key Principles: Time management, values, and ethics.]</li>
                        <li>Content & Activities:]
                            <ul>
                                <li>Family workshops.]</li>
                                <li>Career ethics.]</li>
                                <li>Community involvement.]</li>
                                <li>Gurbani application in daily life.]</li>
                                <li>Stress management.]</li>
                            </ul>
                        </li>
                        <li>Team: Community Development]</li>
                    </ul>

                    <h4>Group 17: 33-34 years]</h4>
                    <ul>
                        <li>Core Focus: Personal and spiritual growth.]</li>
                        <li>Key Principles: Self-reflection, meditation, and seva.]</li>
                        <li>Content & Activities:]
                            <ul>
                                <li>Advanced Gurbani study.]</li>
                                <li>Meditation and mindfulness.]</li>
                                <li>Seva projects.]</li>
                                <li>Mentorship.]</li>
                                <li>Ethical leadership.]</li>
                            </ul>
                        </li>
                        <li>Team: Gurbani Curriculum, Community Development]</li>
                    </ul>

                    <h4>Group 18: 35-36 years]</h4>
                    <ul>
                        <li>Core Focus: Community leadership and impact.]</li>
                        <li>Key Principles: Contribution, responsibility, and legacy.]</li>
                        <li>Content & Activities:]
                            <ul>
                                <li>Community projects.]</li>
                                <li>Gurdwara governance.]</li>
                                <li>Mentoring.]</li>
                                <li>Family and professional ethics.]</li>
                                <li>Philanthropy.]</li>
                            </ul>
                        </li>
                        <li>Team: All Teams]</li>
                    </ul>

                    <h3>Category: Middle Age</h3>

                    <h4>Group 19: 37-38 years]</h4>
                    <ul>
                        <li>Core Focus: Mentoring and guiding younger generations.]</li>
                        <li>Key Principles: Wisdom sharing, community support.]</li>
                        <li>Content & Activities:]
                            <ul>
                                <li>Mentorship programs.]</li>
                                <li>Community leadership roles.]</li>
                                <li>Advanced Gurbani study.]</li>
                                <li>Family and career guidance.]</li>
                                <li>Ethical decision-making.]</li>
                            </ul>
                        </li>
                        <li>Team: Community Development]</li>
                    </ul>

                    <h4>Group 20: 39-40 years]</h4>
                    <ul>
                        <li>Core Focus: Deepening spiritual connection.]</li>
                        <li>Key Principles: Self-reflection, meditation, and seva.]</li>
                        <li>Content & Activities:]
                            <ul>
                                <li>Advanced Gurbani study.]</li>
                                <li>Meditation and mindfulness.]</li>
                                <li>Seva projects.]</li>
                                <li>Community outreach.]</li>
                                <li>Ethical leadership.]</li>
                            </ul>
                        </li>
                        <li>Team: Gurbani Curriculum, Community Development]</li>
                    </ul>

                    <h4>Group 21: 41-42 years]</h4>
                    <ul>
                        <li>Core Focus: Contributing to community and legacy.]</li>
                        <li>Key Principles: Impact, responsibility, and service.]</li>
                        <li>Content & Activities:]
                            <ul>
                                <li>Community projects and initiatives.]</li>
                                <li>Gurdwara governance and leadership.]</li>
                                <li>Mentoring and guiding youth.]</li>
                                <li>Family and professional ethics.]</li>
                                <li>Philanthropic endeavors.]</li>
                            </ul>
                        </li>
                        <li>Team: All Teams]</li>
                    </ul>

                    <h4>Group 22: 43-44 years]</h4>
                    <ul>
                        <li>Core Focus: Balancing personal and spiritual growth.]</li>
                        <li>Key Principles: Self-reflection, meditation, and community.]</li>
                        <li>Content & Activities:]
                            <ul>
                                <li>Advanced Gurbani study.]</li>
                                <li>Meditation and mindfulness practices.]</li>
                                <li>Community service and outreach.]</li>
                                <li>Mentoring and guidance.]</li>
                                <li>Ethical leadership and decision-making.]</li>
                            </ul>
                        </li>
                        <li>Team: Gurbani Curriculum, Community Development]</li>
                    </ul>

                    <h4>Group 23: 45-46 years]</h4>
                    <ul>
                        <li>Core Focus: Mentoring and guiding younger generations.]</li>
                        <li>Key Principles: Wisdom sharing, community support.]</li>
                        <li>Content & Activities:]
                            <ul>
                                <li>Mentorship programs.]</li>
                                <li>Community leadership roles.]</li>
                                <li>Advanced Gurbani study.]</li>
                                <li>Family and career guidance.]</li>
                                <li>Ethical decision-making.]</li>
                            </ul>
                        </li>
                        <li>Team: Community Development]</li>
                    </ul>

                    <h4>Group 24: 47-48 years]</h4>
                    <ul>
                        <li>Core Focus: Deepening spiritual connection and reflection.]</li>
                        <li>Key Principles: Self-reflection, meditation, and seva.]</li>
                        <li>Content & Activities:]
                            <ul>
                                <li>Advanced Gurbani study.]</li>
                                <li>Meditation and mindfulness.]</li>
                                <li>Seva projects.]</li>
                                <li>Community outreach.]</li>
                                <li>Ethical leadership.]</li>
                            </ul>
                        </li>
                        <li>Team: Gurbani Curriculum, Community Development]</li>
                    </ul>

                    <h4>Group 25: 49-50 years]</h4>
                    <ul>
                        <li>Core Focus: Contributing to community and legacy.]</li>
                        <li>Key Principles: Impact, responsibility, and service.]</li>
                        <li>Content & Activities:]
                            <ul>
                                <li>Community projects and initiatives.]</li>
                                <li>Gurdwara governance and leadership.]</li>
                                <li>Mentoring and guiding youth.]</li>
                                <li>Family and professional ethics.]</li>
                                <li>Philanthropic endeavors.]</li>
                            </ul>
                        </li>
                        <li>Team: All Teams]</li>
                    </ul>

                    <h3>Category: Pre-Retirement</h3>

                    <h4>Group 26: 51-52 years]</h4>
                    <ul>
                        <li>Core Focus: Knowledge transfer and spiritual focus.]</li>
                        <li>Key Principles: Wisdom sharing, reflection.]</li>
                        <li>Content & Activities:]
                            <ul>
                                <li>Advanced Gurbani interpretation.]</li>
                                <li>Mentoring younger adults.]</li>
                                <li>Community guidance.]</li>
                                <li>Legacy projects.]</li>
                            </ul>
                        </li>
                        <li>Team: Community Development]</li>
                    </ul>

                    <h4>Group 27: 53-54 years]</h4>
                    <ul>
                        <li>Core Focus: Spiritual preparation and guidance.]</li>
                        <li>Key Principles: Reflection, meditation.]</li>
                        <li>Content & Activities:]
                            <ul>
                                <li>Gurbani study and discussion.]</li>
                                <li>Sikhi way of meditation practices.]</li>
                                <li>Ethical decision-making.]</li>
                                <li>Life review and planning.]</li>
                            </ul>
                        </li>
                        <li>Team: Gurbani Curriculum, Community Development]</li>
                    </ul>

                    <h4>Group 28: 55-56 years]</h4>
                    <ul>
                        <li>Core Focus: Sharing wisdom and experience.]</li>
                        <li>Key Principles: Mentorship, guidance.]</li>
                        <li>Content & Activities:]
                            <ul>
                                <li>Mentoring individuals and families.]</li>
                                <li>Community leadership roles.]</li>
                                <li>Gurbani classes and discussions.]</li>
                                <li>Ethical leadership.]</li>
                            </ul>
                        </li>
                        <li>Team: Community Development]</li>
                    </ul>

                    <h4>Group 29: 57-58 years]</h4>
                    <ul>
                        <li>Core Focus: Deepening spiritual practices.]</li>
                        <li>Key Principles: Contemplation, connection.]</li>
                        <li>Content & Activities:]
                            <ul>
                                <li>Advanced Gurbani study.]</li>
                                <li>Sikhi way of meditation and mindfulness.]</li>
                                <li>Spiritual retreats.]</li>
                                <li>Ethical and philosophical discussions.]</li>
                            </ul>
                        </li>
                        <li>Team: Gurbani Curriculum, Community Development]</li>
                    </ul>

                    <h4>Group 30: 59-60 years]</h4>
                    <ul>
                        <li>Core Focus: Legacy and community contribution.]</li>
                        <li>Key Principles: Service, wisdom sharing.]</li>
                        <li>Content & Activities:]
                            <ul>
                                <li>Community projects.]</li>
                                <li>Documenting family/community history.]</li>
                                <li>Mentoring and guidance.]</li>
                                <li>Ethical and spiritual legacy.]</li>
                            </ul>
                        </li>
                        <li>Team: All Teams]</li>
                    </ul>

                    <p>This is a very detailed plan, and it's important to remember that it's a framework. Spiritual blessings, flexibility and adaptation will be key to success.]</p>

                </div>
            </div>
        </Fragment>
    )
};

export default GurshikhaProject
